import { render, staticRenderFns } from "./MFormFiles.vue?vue&type=template&id=2ccc0d54&scoped=true&"
import script from "./MFormFiles.vue?vue&type=script&lang=js&"
export * from "./MFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./MFormFiles.vue?vue&type=style&index=0&id=2ccc0d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc0d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccc0d54')) {
      api.createRecord('2ccc0d54', component.options)
    } else {
      api.reload('2ccc0d54', component.options)
    }
    module.hot.accept("./MFormFiles.vue?vue&type=template&id=2ccc0d54&scoped=true&", function () {
      api.rerender('2ccc0d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MFormFiles.vue"
export default component.exports